
import {Generic} from "./generic";

export class Cliente extends Generic{
    id: string;
    dscliente: string;
    dtatualizacao: string;
}